import mitt from 'mitt';
import type { AppNotification } from '~/dto/app-notification';

export default defineNuxtPlugin({
  parallel: false,
  setup: () => {
    const emitter = mitt();
    return {
      provide: {
        eventBus: {
          on: emitter.on,
          off: emitter.off,
          emit: emitter.emit,
          // error: (err: unknown) => emitter.emit('error', err),
          notification: (notif: AppNotification) => emitter.emit('notification', notif),
        },
      },
    };
  }
});